import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function ElectricalEngineering() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/elkonstruktion-styretavle.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/8a3e6d-38f93c76eb184f888d48b892497ae3dc.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Elkonstruktion - JARCon ApS"
        description="Konstruktion og opbygning af styretavler efter gældende standarder. Udfærdige mekanisk og elektrisk dokumentation (PC Schematik) på Dansk, Tysk og Engelsk. CE mærkning."
      />

      <PageHeader
        badge="Konsulentydelser"
        title="Elkonstruktion"
        subtitle="Styretavler og eldiagrammer efter gældende standarder • PC Schematik • CE mærkning"
        breadcrumbs={[
          { label: 'Konsulentydelser', path: '/konsulentydelser' },
          { label: 'Elkonstruktion' },
        ]}
        ctaText="Kontakt os om styretavler"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Standarder &amp; Elsikkerhed
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Styretavler og eldiagrammer
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Konstruktion og opbygning af styretavler efter gældende standarder.
              </p>
              <p className="text-slate-300 text-base leading-relaxed">
                Udfærdige mekanisk og elektrisk dokumentation (PC Schematik) på Dansk, Tysk og Engelsk. CE mærkning.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Vi bygger styretavler til automatiserede maskiner, produktionslinjer og specialanlæg med professionel komponentplacering, tydelig opmærkning og overholdelse af gældende EN/IEC standarder for maskinsikkerhed.
              </p>
            </div>

            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-6">
              <h3 className="font-display text-xl font-bold text-white flex items-center gap-2">
                <i className="fa-solid fa-file-code text-cyan-400 text-base" aria-hidden="true" />
                PC Schematik &amp; Dokumentation
              </h3>
              <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
                Et velfungerende elanlæg kræver præcis dokumentation. Vi udarbejder fulde strømskemaer, klemmerækker, kabellister og komponentfortegnelser i PC Schematik.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 font-open-sans text-xs">
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800">
                  <span className="text-cyan-400 font-semibold block mb-1">Dansk</span>
                  <span className="text-slate-400">Komplet dokumentation til det danske marked</span>
                </div>
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800">
                  <span className="text-cyan-400 font-semibold block mb-1">Tysk</span>
                  <span className="text-slate-400">Tekniske diagrammer og lister på tysk</span>
                </div>
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800">
                  <span className="text-cyan-400 font-semibold block mb-1">Engelsk</span>
                  <span className="text-slate-400">International standarddokumentation</span>
                </div>
              </div>
            </div>

            <GalleryGrid
              title="Elkonstruktion og styretavler galleri"
              subtitle="Klik på billederne for at se forstørret visning"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-cyan-400" />
                Ydelsens omfang
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Styretavler efter gældende standarder</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Eldiagrammer i PC Schematik</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Dokumentation på Dansk, Tysk og Engelsk</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>CE mærkning af elinstallationer</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Elektrisk montage og indkøring</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Spørgsmål til elkonstruktion?
              </span>
              <h4 className="font-display font-bold text-lg text-white">
                Få teknisk rådgivning om tavler og standarder
              </h4>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
